// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const LANDING_OPTIONS_MODAL_COMPONENT_FOOTER_PROPS = {
    'data-testid': 'landing-options-modal-component-footer',
    'variant': VARIANTS.FooterVariantsType.ONE_ACTION,
  },
  LANDING_OPTIONS_MODAL_COMPONENT_FOOTER_ACTION_BUTTON_PROPS = {
    'data-testid': 'landing-options-modal-component-footer-action-button',
    'size': 'LARGE',
    'type': 'PRIMARY',
    'rwdFull': true,
  };

export {
  LANDING_OPTIONS_MODAL_COMPONENT_FOOTER_ACTION_BUTTON_PROPS,
  LANDING_OPTIONS_MODAL_COMPONENT_FOOTER_PROPS,
};
